export const getBingoComponent =
    (component: keyof typeof import('./bingo-lobby.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "games" */
            './bingo-lobby.chunk'
        );
        return chunk[component];
    };
